export const resoluciones = [
    {
        "anio" : "2016",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "01-2016",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/01_2016.pdf"
            },
            {
                "trimestre" : "3-2016",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/3_2016.pdf"
            },
            {
                "trimestre" : "7-2016",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/7_2016.pdf"
            },
            {
                "trimestre" : "10-2016",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/10_2016.pdf"
            }
        ]
    },
    {
        "anio" : "2016",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "11-2016",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/11_2016.pdf"
            },
            {
                "trimestre" : "13-2016",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/13_2016.pdf"
            },
            {
                "trimestre" : "14-2016",
                "url" : "whttp://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/14_2016.pdf"
            },
            {
                "trimestre" : "15-2016",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/15_2016.pdf"
            }
        ]
    },
    {
        "anio" : "2016",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "16-2016",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/16_2016.pdf"
            },
            {
                "trimestre" : "20-2016",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/resoluciones/20_2016.pdf"
            }
        ]
    }
]